import { render, staticRenderFns } from "./AddonProductModal.vue?vue&type=template&id=5b0955ac&"
import script from "./AddonProductModal.vue?vue&type=script&lang=js&"
export * from "./AddonProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0955ac')) {
      api.createRecord('5b0955ac', component.options)
    } else {
      api.reload('5b0955ac', component.options)
    }
    module.hot.accept("./AddonProductModal.vue?vue&type=template&id=5b0955ac&", function () {
      api.rerender('5b0955ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/AddonProductModal.vue"
export default component.exports